@switch (itemType) {
  @case ('movie') {
    <movie-suggestion-item (click)="handleItemSelect(item)" [item]="item"></movie-suggestion-item>
  }
  @case ('star') {
    <star-suggestion-item (click)="handleItemSelect(item)" [item]="item"></star-suggestion-item>
  }
  @case ('user') {
    <user-suggestion-item (click)="handleItemSelect(item)" [item]="item"></user-suggestion-item>
  }
}
